// 2026-27 NHL special events (outdoor + Global Series). Matched by team pair + date (±1 day).
const EVENTS = [
    { key: "heritage", title: "Heritage Classic", date: ["2026-10-25"], teams: ["MTL", "WPG"], accent: "#E8B866",
        bg: "repeating-linear-gradient(90deg, rgba(160,40,40,0.20) 0 14px, transparent 14px 28px), repeating-linear-gradient(0deg, rgba(160,40,40,0.16) 0 14px, transparent 14px 28px), linear-gradient(135deg, #2A1410, #3B1E14)" },
    { key: "winter", title: "Winter Classic", date: ["2026-12-31"], teams: ["UTA", "COL"], accent: "#A8DCF5",
        bg: "radial-gradient(circle at 15% 20%, rgba(255,255,255,0.14) 0 1.5px, transparent 2px), radial-gradient(circle at 70% 65%, rgba(255,255,255,0.12) 0 1.5px, transparent 2px), linear-gradient(160deg, #0E2A47, #123A5E 60%, #0B2238)" },
    { key: "stadium", title: "Stadium Series", date: ["2027-02-20"], teams: ["DAL", "VGK"], accent: "#3DFFA2",
        bg: "radial-gradient(ellipse at 10% -20%, rgba(61,255,162,0.22), transparent 55%), radial-gradient(ellipse at 90% -20%, rgba(200,210,220,0.18), transparent 55%), linear-gradient(180deg, #07110D, #0A0D10)" },
    { key: "gs-fin", title: "Global Series · Finland", date: ["2026-11-12", "2026-11-14"], teams: ["CAR", "SEA"], accent: "#7FB2FF",
        bg: "linear-gradient(90deg, transparent 22%, rgba(0,47,108,0.55) 22% 32%, transparent 32%), linear-gradient(0deg, transparent 40%, rgba(0,47,108,0.55) 40% 60%, transparent 60%), linear-gradient(135deg, #10151F, #161C2A)" },
    { key: "gs-ger", title: "Global Series · Germany", date: ["2026-12-18", "2026-12-20"], teams: ["OTT", "CHI"], accent: "#FFCE00",
        bg: "linear-gradient(180deg, rgba(0,0,0,0.55) 0 33%, rgba(221,0,0,0.28) 33% 66%, rgba(255,206,0,0.20) 66%), linear-gradient(135deg, #121212, #1A1414)" },
];

const DAY = 864e5;
export function specialEventFor(g) {
    const t = g?.startTimeUTC ? Date.parse(g.startTimeUTC) : null;
    if (!t) return null;
    const pair = [g.home?.abbr, g.away?.abbr];
    return EVENTS.find((e) => e.teams.every((x) => pair.includes(x)) && e.date.some((d) => Math.abs(Date.parse(`${d}T18:00:00Z`) - t) <= DAY)) || null;
}

// Card style for an event. mode: "themed" (full design) | "badge" (normal card + coloured edge).
export function eventCardStyle(ev, open) {
    if (!ev) return undefined;
    return { background: ev.bg, borderColor: open ? "#FFFFFFAA" : `${ev.accent}88` };
}

// Dark team colours are lifted toward white so the title/border stay readable.
const lift = (hex) => {
    const n = parseInt(String(hex || "#8A94A6").slice(1), 16); let r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    if (0.2126 * r + 0.7152 * g + 0.0722 * b > 110) return hex;
    [r, g, b] = [r, g, b].map((c) => Math.round(c + (255 - c) * 0.5));
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
};
// Home opener: themed in the HOME team's colours (owner switch, PWHL + NHL).
export function homeOpenerEvent(primary) {
    const p = primary || "#8A94A6";
    return {
        key: "home-opener", title: "Home Opener", accent: lift(p),
        bg: `radial-gradient(ellipse at 0% 0%, ${p}66, transparent 60%), radial-gradient(ellipse at 100% 100%, ${p}33, transparent 55%), repeating-linear-gradient(135deg, rgba(255,255,255,0.025) 0 2px, transparent 2px 10px), linear-gradient(135deg, #12131A, #0B0C10)`,
    };
}

// Title sits ON the top border (absolute), so the card never grows.
export const EventTitle = ({ ev, gid }) => ev ? (
    <span className="pointer-events-none absolute -top-[7px] left-3 z-[1] px-1.5 rounded bg-[#0B0C10] text-[8px] leading-[14px] font-black uppercase tracking-[0.18em] whitespace-nowrap"
        style={{ color: ev.accent, boxShadow: `0 0 0 1px ${ev.accent}66` }} data-testid={`nhl-event-title-${gid}`}>{ev.title}</span>
) : null;
